import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { VideosComponent } from '../videos/videos.component';
import { VideoUploadDialogComponent } from './dialog/video-upload-dialog/video-upload-dialog.component';

@NgModule({
  declarations: [VideosComponent, VideoUploadDialogComponent],
  imports: [CommonModule, SharedModule],
  exports: [VideosComponent],
})
export class VideosModule {}
